import React, { useState, useContext, useLayoutEffect } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Avatar from '@mui/material/Avatar'
import { ContextoGlobal, ContextoGlobalInterface } from '../GlobalStates/ContextoGlobal'

import { styled } from '@mui/material/styles'
import { MenuOpcoesInterface } from './MenuCls'
import MenuItem from './MenuItem'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ClsPesquisaClienteAtual from '../View/Controller/ClsPesquisaClienteAtual'

const Offset = styled( 'div' )( ( { theme } ) => theme.mixins.toolbar )

export default function ElevateAppBar () {

  const navigate = useNavigate()

  const contextoGlobal = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const {
    loginState,
    layoutState,
    setLayoutState,
  } = contextoGlobal

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>( null )

  const handleOpenUserMenu = ( event: React.MouseEvent<HTMLElement> ) => {
    setAnchorElUser( event.currentTarget )
  }

  useLayoutEffect( () => {
    const clsPesquisaClienteAtual: ClsPesquisaClienteAtual = new ClsPesquisaClienteAtual()
    clsPesquisaClienteAtual.setarDescricaoCliente( loginState.idClienteAtual, contextoGlobal, layoutState, setLayoutState )

    // setLayoutState( { ...layoutState, descricaoClienteAtual: 'Effect' } )
  }, [loginState.idClienteAtual] )

  const handleCloseUserMenu = () => {
    setAnchorElUser( null )
  }

  const iniciaisNome = (): string => {
    return loginState.nome.split( ' ' ).map( ( n ) => n[0] ).join( '' )
  }

  const toogleDrawer = () => {
    setLayoutState( { ...layoutState, exibirMenu: !layoutState.exibirMenu } )
  }

  const opcoesMenu: Array<MenuOpcoesInterface> = [
    {
      descricao: 'Alterar Senha',
      filhos: [],
      icon: 'lock_reset',
      modulo: '',
      permissao: '',
      path: '/AlterarSenha'
    },
    {
      descricao: 'Logout',
      filhos: [],
      icon: 'logout',
      modulo: '',
      permissao: '',
      path: '/Logout'
    }
  ]

  return (
    <>
      <AppBar>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toogleDrawer}
            edge="start"
            sx={{ mr: 2, flexGrow: 0 }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1 }} >
            <Box
              component="img"
              sx={{
                mt: 1.5,
                maxWidth: { xs: 20, md: 40 },
              }}
              alt={process.env.REACT_APP_TITULO}
              src={process.env.REACT_APP_PASTA?.concat( "/logobranca.png" )}
            />
          </Box>

          <Box sx={{ flexGrow: 0, mr: 1, textAlign: 'right' }} >
            <Button variant='contained' disableElevation onClick={() => navigate( '/SetCliente' )}>{layoutState.descricaoClienteAtual}</Button>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Configurações">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar>{iniciaisNome()}</Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean( anchorElUser )}
              onClose={handleCloseUserMenu}
            >
              {opcoesMenu.map( ( menu: MenuOpcoesInterface, indice: number ) => (
                <MenuItem deslocamento={0} key={indice} menu={menu} />
              ) )}
            </Menu>

          </Box>
        </Toolbar>
      </AppBar>
      <Offset />
    </>
  )
}